/**
 * Strategy pattern for AIForMe data retrieval
 */

import { config } from "config";

import {
  AIForMeTool,
  CATEGORIES,
  DATA_CLASSIFICATION,
  DataDomainMetadata,
  JOB_FAMILIES,
  SORTING_PRIORITY,
} from "../models/aiforme-models";
import { CatalogicalService } from "./catalogical-service";

export interface AIForMeDataService {
  getMetadata(): Promise<DataDomainMetadata>;
}

/**
 * Hardcoded data provider (current implementation)
 */
export class AIForMeHardcodedService implements AIForMeDataService {
  async getMetadata(): Promise<DataDomainMetadata> {
    return {
      enums: {
        categories: CATEGORIES.map((category) => ({
          label: category,
          value: category,
        })),
        jobFamilies: JOB_FAMILIES.map((jobFamily) => ({
          label: jobFamily,
          value: jobFamily,
        })),
        sortingPriority: SORTING_PRIORITY.map((priority) => ({
          label: priority.label,
          value: priority.value,
        })),
        dataClassification: DATA_CLASSIFICATION.map((classification) => ({
          label: classification,
          value: classification,
        })),
      },
    };
  }
}

/**
 * API-based data provider
 */
export class AIForMeService extends CatalogicalService<AIForMeTool> implements AIForMeDataService {
  constructor() {
    super("aiforme");
  }

  async getMetadata(): Promise<DataDomainMetadata> {
    const response = await this.fetch(`/domains/${this.domain}/metadata`);
    return response.json();
  }
}

/**
 * Factory to create the appropriate provider
 */
export class AIForMeDataServiceFactory {
  static create(useAPIService?: boolean): AIForMeDataService {
    const shouldUseAPIService = useAPIService ?? config.useAIForMeAPIService;
    return shouldUseAPIService ? new AIForMeService() : new AIForMeHardcodedService();
  }
}
